export default __webpack_public_path__ + "static/media/project11.5f32bed2.webp";